import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';

import config from 'config/config';
import { firebase } from 'config/firebase';

import { createStore } from '../utilities';

const Redux = ({ children, initialState, reducers, saga, middlewares }) => {
    const store = createStore({ initialState, reducers, saga, middlewares });

    return (
        <Provider store={store}>
            <ReactReduxFirebaseProvider firebase={firebase} config={config.rrf} dispatch={store.dispatch}>
                {children}
            </ReactReduxFirebaseProvider>
        </Provider>
    );
};

Redux.propTypes = {
    children: PropTypes.node.isRequired,
    // eslint-disable-next-line
    initialState: PropTypes.object,
    // eslint-disable-next-line
    reducers: PropTypes.object.isRequired,
    saga: PropTypes.func,
    middlewares: PropTypes.arrayOf(PropTypes.func),
};

Redux.defaultProps = {
    initialState: {},
    *saga() {
        yield;
    },
    middlewares: [],
};

export default Redux;
